<div class="parent">
  <div class="parentChildOne">
    <p>
      <span>Bank Account Details </span>
    </p>
    <p>
      <span> GTB</span>
    </p>
    <p>
      <span> 01189923445 </span>
    </p>
    <p>
      <span>Eligibility checked </span>
    </p>
    <p>
      <span>Femi Bejide Akintunde</span>
    </p>

    <span class="doneButton">
      <a> Button </a>
    </span>
  </div>
</div>
